export default "__VITE_ASSET__BH_QE5N5__"